import { Block, LabelSmall, ParagraphSmall, useStyletron, } from "@mezo-org/mezo-clay";
import React, { useMemo } from "react";
import { getCryptoAsset } from "../../utils/cryptoAssets";
export default function AccountAssets(props) {
    const { label, assets } = props;
    const [, theme] = useStyletron();
    const assetsData = useMemo(() => assets.map((token) => {
        const { name, symbol, icon } = getCryptoAsset(token.type);
        return {
            ...token,
            icon,
            label: name,
            symbol,
        };
    }), [assets]);
    const labelContent = typeof label === "string" ? (React.createElement(ParagraphSmall, { margin: 0, color: theme.colors.gray800 }, label)) : (label);
    if (assetsData.length === 0) {
        return null;
    }
    return (React.createElement(Block, { padding: `0 ${theme.sizing.scale500}` },
        React.createElement(Block, { margin: `${theme.sizing.scale400} 0` }, labelContent),
        React.createElement(Block, { as: "ul", marginBottom: theme.sizing.scale600, padding: 0, display: "flex", flexDirection: "column", overrides: {
                Block: {
                    style: {
                        gap: theme.sizing.scale100,
                    },
                },
            } }, assetsData.map((asset) => (React.createElement(Block, { as: "li", key: `${asset.type}-${asset.balance}`, display: "flex", justifyContent: "space-between", alignItems: "center", margin: `${theme.sizing.scale100} 0` },
            React.createElement(asset.icon, { size: theme.sizing.scale800, overrides: {
                    Svg: {
                        style: {
                            marginRight: theme.sizing.scale500,
                        },
                    },
                } }),
            React.createElement(Block, { flex: 1 },
                React.createElement(LabelSmall, { margin: 0 }, asset.label),
                React.createElement(ParagraphSmall, { margin: 0, color: theme.colors.gray500 }, asset.symbol)),
            React.createElement(Block, { display: "flex", alignItems: "end", flexDirection: "column" },
                React.createElement(LabelSmall, { margin: 0 }, asset.balance),
                React.createElement(ParagraphSmall, { margin: 0, color: theme.colors.gray500 }, asset.balanceInUsd))))))));
}
//# sourceMappingURL=AccountAssets.js.map